import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../../context/User';
import { useHistory } from 'react-router';
import { Container, Row, Col } from 'react-bootstrap';
import InboxTable from './InboxTable';
import { SearchContext } from '../../context/Search';
import Pagination from '../Pagination';
import PageSwitcher from '../PageSwitcher';
import { myMessagesGet } from '../../api';
import Loading from 'components/Loading';
import { somethingWentWrongNotice } from '../UI/Notifications';

const Inbox = ({ trigger, setTrigger }) => {
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [messageData, setMessageData] = useState([]);
  const [forcePage, setForcePage] = useState(0);
  const [triggerSearch, setTriggerSearch] = useState(false);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();
  const [isntReadMessages, setIsntReadMessages] = useState(0); 

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Inbox");
    }
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    myMessagesGet({
      limit: 1,
      only_unread: true
    })
      .then(response => {
        setMessageData(response.data.results);
        setIsntReadMessages(response.data.total_count);
        setLoading(false);
      })
      .catch(error => {
        if(error.response.status !== 404) {handleDefaultStatusCodes(error.response.status);}
        else {setIsntReadMessages(0);};
        setLoading(false);
      })
  }, [triggerSearch]);

  useEffect(() => {
    setLoading(true);
    myMessagesGet({
      limit: limit,
      offset: offset
    })
      .then(response => {
        setMessageData(response.data.results);
        setTotalCount(response.data.total_count);
        setLoading(false);
      })
      .catch(error => {
        if(error.response.status !== 404) {handleDefaultStatusCodes(error.response.status);}
        else {
          setTotalCount(0); 
          setMessageData([]);
        };
        setLoading(false);
      })
  }, [triggerSearch]);

  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5">
              My Message Center {!!isntReadMessages && `(${(isntReadMessages)})`}
            </h3>
          </Col>
        </Row>
        {!totalCount && (
          <Row>
            <Col>
              <h3>
                No results
              </h3>
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <InboxTable 
              messageData={messageData}
              setLoading={setLoading}
              triggerSearch={triggerSearch} 
              setTriggerSearch={setTriggerSearch}
              handleDefaultStatusCodes={handleDefaultStatusCodes}
              setTrigger={setTrigger}
              trigger={trigger}
            />
          </Col>
        </Row>
        <SearchContext.Provider value={{offset, setOffset, totalCount, limit, setForcePage, forcePage, setPageCount, pageCount}}>
          {messageData && !!messageData.length && (
            <Row>
              <Col>
                <div className="pagination-wrap">
                  <Pagination />
                  <PageSwitcher />
                </div>
              </Col>
            </Row>
          )}
        </SearchContext.Provider>
      </Container>
      {loading && <Loading />}
    </section>  
  )
}

export default Inbox;